import React, {createRef} from "react";
import clsx from "clsx";

export default function Submit(props) {

    const buttonRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    return <div id={data.id} className={clsx("sendiio-form-submit-element", `sendiio-form-button-alignment-${data.buttonAlignment}`)}>

            <button
                ref={buttonRef}
                id={`btn-${data.id}-submit`}
                className="sendiio-form-submit-button cursor-text"
                placeholder=""
                format="text"
                contentEditable={true}
                suppressContentEditableWarning={true}
                type="button"
                onBlur={e => {

                    if(data.buttonText !== e.currentTarget.textContent){

                        data.buttonText = e.currentTarget.textContent;

                        updateFormData(data);

                        buttonRef.current.textContent = e.currentTarget.textContent;

                    }

                }}
                dangerouslySetInnerHTML={{__html: data.buttonText}} />

        </div>

}